export const SPATIAL_GRID_CELL_SIZE = 512
